<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<!--START OPTIONS-->
					<!--SchoolID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School</label>
						<div class="col-sm-4 col-lg-3">
							<!-- <select class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="report.SchoolID">
                                <option value="" style="display:none;"></option>
                                <option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">{{o.SchoolName}}</option>
                            </select> -->

							<caass-schoolselector
								[Disabled]="IsLoading() == true"
								[ShowAll]="true"
								[ShowAllID]="SchoolSelectShowAllID"
								[ShowAllText]="SchoolSelectShowAllText"
								[IsReport]="true"
								[ReportID]="439"
							>
							</caass-schoolselector>
						</div>
					</div>

					<!--GradeLevelID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Grade Level</label>
						<div class="col-sm-4 col-lg-3">
							<select [disabled]="IsLoading() == true" class="form-control" name="GradeLevelID" [(ngModel)]="report.GradeLevelID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of GradeLevelList" [ngValue]="o.GradeLevelID">
									{{ o.GradeLevelDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--ACADEMYID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Academy</label>
						<div class="col-sm-4 col-lg-3">
							<select [disabled]="IsLoading() == true" class="form-control" name="AcademyID" [(ngModel)]="report.AcademyID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of AcademyList" [ngValue]="o.AcademyId">
									{{ o.AcademyDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--HOMEROOMID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Homeroom</label>
						<div class="col-sm-4 col-lg-3">
							<select [disabled]="IsLoading() == true" class="form-control" name="HomeroomID" [(ngModel)]="report.HomeroomID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of HomeroomList" [ngValue]="o.HomeroomId">
									{{ o.HomeRoom }}
								</option>
							</select>
						</div>
					</div>

					<!--GROUPID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Group</label>
						<div class="col-sm-4 col-lg-3">
							<select [disabled]="IsLoading() == true" class="form-control" name="GroupID" [(ngModel)]="report.GroupID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of GroupList" [ngValue]="o.GroupID">
									{{ o.GroupName }}
								</option>
							</select>
						</div>
					</div>

					<!--STARTDATE-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Start Date</label>
						<div class="col-sm-4 col-lg-3">
							<p-calendar
								[disabled]="IsLoading() == true"
								showIcon="true"
								showButtonBar="true"
								[(ngModel)]="report.STARTDATE"
								name="txtSTARTDATE"
							></p-calendar>
						</div>
					</div>

					<!--ENDDATE-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">End Date</label>
						<div class="col-sm-4 col-lg-3">
							<p-calendar
								[disabled]="IsLoading() == true"
								showIcon="true"
								showButtonBar="true"
								[(ngModel)]="report.ENDDATE"
								name="txtENDDATE"
							></p-calendar>
						</div>
					</div>

					<!--PointsCategoryTypeID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Point Type</label>
						<div class="col-sm-4 col-lg-3">
							<select
								[disabled]="IsLoading() == true"
								class="form-control"
								name="PointsCategoryTypeID"
								[(ngModel)]="report.PointsCategoryTypeID"
								(ngModelChange)="onPointCategoryTypeChange($event)"
							>
								<option value="" style="display: none"></option>
								<option *ngFor="let o of PointsCategoryTypeList" [ngValue]="o.PointsCategoryTypeID">
									{{ o.PointsCategoryTypeDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--PointsCategoryID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Point Category</label>
						<div class="col-sm-4 col-lg-3">
							<select
								[disabled]="IsLoading() == true"
								class="form-control"
								name="PointsCategoryID"
								[(ngModel)]="report.PointsCategoryID"
								(ngModelChange)="onPointCategoryChange($event)"
							>
								<option value="" style="display: none"></option>
								<option *ngFor="let o of PointsCategoryList" [ngValue]="o.PointsCategoryID">
									{{ o.PointsCategoryDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--PointsItemID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Point</label>
						<div class="col-sm-4 col-lg-3">
							<select [disabled]="IsLoading() == true" class="form-control" name="PointsItemID" [(ngModel)]="report.PointsItemID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of PointsItemList" [ngValue]="o.PointsItemID">
									{{ o.PointsItemDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--OrderBy-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Order By</label>
						<div class="col-sm-4 col-lg-3">
							<select [disabled]="IsLoading() == true" class="form-control" name="OrderByID" [(ngModel)]="report.OrderByID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OrderByList" [ngValue]="o.OrderByID">
									{{ o.OrderByName }}
								</option>
							</select>
						</div>
					</div>

					<!--ShowDetail-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Show Detail</label>
						<div class="col-sm-4 col-lg-3">
							<select [disabled]="IsLoading() == true" class="form-control" name="ShowDetailID" [(ngModel)]="report.ShowDetailID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ShowDetailList" [ngValue]="o.ShowDetailID">
									{{ o.ShowDetailName }}
								</option>
							</select>
						</div>
					</div>

					<!--ImageLogo-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Logo</label>
						<div class="col-sm-4 col-lg-3">
							<select [disabled]="IsLoading() == true" class="form-control" name="ImageLogo" [(ngModel)]="report.ImageLogo">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ImageLogoList" [ngValue]="o.ImageLibraryID">
									{{ o.LogoDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--File Type-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Output File Type</label>
						<div class="col-sm-4 col-lg-3">
							<select [disabled]="IsLoading() == true" class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--Submit Form-->
					<div class="hr-line-dashed"></div>
					<div class="form-group">
						<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
							{{ errorMessage }}
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>
						<div class="col-md-4 col-lg-3">
							<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
							<button
								name="btnSaving"
								*ngIf="!isProcessing"
								[disabled]="IsLoading() == true"
								class="btn btn-primary"
								type="button"
								(click)="Print()"
							>
								Print
							</button>
							<button
								name="btnMerge"
								*ngIf="!isProcessing"
								class="btn btn-primary"
								style="margin-left: 5px"
								type="button"
								(click)="MergeToGroup()"
							>
								Merge to Group
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
